module.exports = __webpack_public_path__ + "static/media/patientDashboard.045091c5.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/patientDashboard.PNG
// module id = 391
// module chunks = 0